import { useAuthState, useAuthDispatch } from "../context/AuthContext";
import axios from "../api/axios";

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const useAuth = () => {
  const state = useAuthState();
  const dispatch = useAuthDispatch();

  const fetchCurrentUser = async () => {
    try {
      const res = await axios.get("/api/v1/users/me");
      dispatch({ type: "SET_USER", payload: res.data });
    } catch (error) {
      console.error("Error fetching current user:", error);
      dispatch({ type: "LOGOUT" });
    }
  };

  return { ...state, fetchCurrentUser };
};
